'use client'

import { useEffect } from 'react'
import { usePathname } from 'next/navigation'
import { isPrivateRoute } from '@/lib/private-routes'

interface AnalyticsRouteGuardProps {
  gaId?: string
}

/**
 * Prevent GA from recording private admin/auth routes after client-side navigation.
 */
export default function AnalyticsRouteGuard({
  gaId,
}: AnalyticsRouteGuardProps) {
  const pathname = usePathname()

  useEffect(() => {
    if (!gaId || typeof window === 'undefined') return
    ;(window as any)[`ga-disable-${gaId}`] = isPrivateRoute(pathname || '')
  }, [gaId, pathname])

  return null
}
